import { readStandaloneDisplayModeFromWindow } from '../../utils/isStandaloneDisplayMode';
import { PwaClient } from '../types';

/**
 * Which client is the user on right now?
 *
 * Reuses the existing standalone detection: installed / Home Screen app -> 'pwa',
 * everything else (normal browser tab) -> 'web'.
 *
 * Kept dependency-free on purpose — `src/temp/BerndMapper.ts` and the auth
 * actions import this file directly instead of `features/pwa` to avoid an
 * import cycle through the feature's React components.
 */
export function detectPwaClient(win: Window = window): PwaClient {
    try {
        return readStandaloneDisplayModeFromWindow(win) ? 'pwa' : 'web';
    } catch {
        return 'web';
    }
}

export default detectPwaClient;
